import { API } from "@/boot/api";
import { AxiosResponse } from "axios";
import { errorHandler } from "@packages/frontend-helpers";
import { defineStore } from "pinia";
import { ref, computed } from "vue";

import type { IProfileInfo } from "../types";
import { useStore } from "vuex";
import { PermissionList } from "@/package/global-constants";

export const useProfileStore = defineStore("profileStore", () => {
  const store = useStore();

  const isProfileDrawerOpen = ref(false);

  const profileInfo = ref<IProfileInfo>({
    tariff: {
      id: 1,
      code: "basic",
      activated_at: "",
      expired_at: "",
    },
    email: "",
    phone: null,
    distributor: null,
    manager: null,
  });

  const loadProfileInfo = async () => {
    try {
      const response = await API.get<AxiosResponse<IProfileInfo>>(
        "account/partner-profile"
      );
      profileInfo.value = response.data.data;
    } catch (e: Error | unknown) {
      errorHandler(e);
      throw e;
    }
  };

  const hasUserProfilePermission = computed(() => {
    return store.state.user.permissions.includes(
      PermissionList.PARTNER_PROFILE
    );
  });

  return {
    isProfileDrawerOpen,
    hasUserProfilePermission,
    profileInfo,
    loadProfileInfo,
  };
});
